<template>
  <div v-title="$route.meta.title"
       class="training-bind-history">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试培训管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/training/instruction' }">培训管理</el-breadcrumb-item>
        <el-breadcrumb-item>绑定历史</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="training-bind-history__info-card">
      <div class="training-bind-history__info-row">
        <label class="training-bind-history__info-label">培训名称</label>
        <span class="training-bind-history__info-value">{{ instruction.title || '-' }}</span>
      </div>
      <div class="training-bind-history__info-row">
        <label class="training-bind-history__info-label">培训ID</label>
        <span class="training-bind-history__info-value is-mono">{{ instruction.id }}</span>
      </div>
    </div>

    <div class="training-bind-history__card">
      <div class="training-bind-history__card-header"
           @click="recordsExpanded = !recordsExpanded">
        <span>绑定记录</span>
        <div class="training-bind-history__card-header-actions">
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="training-bind-history__refresh"
                     @click.stop="onRefresh()" />
          <i :class="recordsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
        </div>
      </div>

      <div v-show="recordsExpanded"
           class="training-bind-history__card-body">
        <div v-if="!table.length"
             class="training-bind-history__empty">
          暂无绑定记录
        </div>

        <template v-else>
          <div class="training-bind-history__table-wrap">
            <el-table :data="table"
                      class="training-bind-history__table"
                      style="width: 100%">
              <el-table-column label="项目"
                               min-width="180">
                <template v-slot="scope">
                  <span>{{ scope.row.project_name || '-' }}</span>
                  <span v-if="scope.row.project_id"
                        class="training-bind-history__sub-id">/ {{ scope.row.project_id }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="project_number"
                               label="项目编号"
                               min-width="140">
                <template v-slot="scope">
                  <span class="training-bind-history__mono">{{ scope.row.project_number || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="项目时间"
                               min-width="200">
                <template v-slot="scope">
                  <span v-if="scope.row.project_starttime || scope.row.project_endtime">
                    {{ formatProjectTime(scope.row) }}
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="项目状态"
                               width="110">
                <template v-slot="scope">
                  <span v-if="scope.row.project_status_name"
                        :class="['training-bind-history__status-tag', getProjectStatusClass(scope.row)]">
                    {{ scope.row.project_status_name }}
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="批次"
                               min-width="160">
                <template v-slot="scope">
                  <span>{{ scope.row.batch_name || '-' }}</span>
                  <span v-if="scope.row.batchid"
                        class="training-bind-history__sub-id">/ {{ scope.row.batchid }}</span>
                </template>
              </el-table-column>
              <!--
                原型含「绑定状态」「解绑时间」列，当前业务仅支持批次一次性绑定（bindBatch 不可修改/解绑），
                有绑定记录即表示仍绑定中，故不展示上述两列，避免误导为可解绑。
              -->
              <el-table-column prop="created_at"
                               label="绑定时间"
                               width="170" />
              <el-table-column label="操作人"
                               min-width="140">
                <template v-slot="scope">
                  <template v-if="scope.row.creator_id">
                    <span>{{ scope.row.creator_username || '-' }}</span>
                    <span class="training-bind-history__sub-id">/ {{ scope.row.creator_id }}</span>
                  </template>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagination">
            <el-pagination background
                           @size-change="handleSizePageChange"
                           @current-change="handleCurrentPageChange"
                           :current-page="pagination.current_page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="pagination.per_page"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="pagination.total" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import tableMixin from '@core/mixins/table-v3'

export default {
  mixins: [tableMixin],
  data () {
    return {
      recordsExpanded: true,
      instruction: {
        id: this.$route.params.id,
        title: this.$route.query.title || '',
      },
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
    }
  },
  created () {
    this.loadInstruction()
  },
  methods: {
    loadInstruction () {
      request.common('getTrainingInstruction', { id: this.instruction.id }).then(({ data }) => {
        this.instruction.title = data.title
      }).catch(() => {})
    },
    getRouterQueryParams (query = this.$route.query) {
      return tableMixin.methods.getRouterQueryParams.call(this, query)
    },
    getTableData (params) {
      delete params.id
      delete params.title
      delete params.recordId
      params.training_instruction_id = this.instruction.id
      return request.page('queryTrainingInstructionBatchHistory', params)
    },
    formatProjectTime (row) {
      if (row.project_starttime && row.project_endtime) {
        return `${row.project_starttime} 至 ${row.project_endtime}`
      }
      return row.project_starttime || row.project_endtime || '-'
    },
    getProjectStatusClass (row) {
      const activeNames = ['开立', '审核中']
      return activeNames.includes(row.project_status_name)
        ? 'is-active'
        : 'is-default'
    },
  },
}
</script>

<style lang="scss" scoped>
.training-bind-history {
  &__info-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    padding: 24px;
    margin-bottom: 16px;
  }

  &__info-row {
    display: grid;
    grid-template-columns: minmax(120px, 16.666%) minmax(0, 1fr);
    gap: 16px;
    align-items: center;

    & + & {
      margin-top: 12px;
    }
  }

  &__info-label {
    color: #909399;
    font-size: 14px;
  }

  &__info-value {
    color: #303133;
    font-size: 14px;
    word-break: break-all;

    &.is-mono {
      font-family: Menlo, Monaco, Consolas, monospace;
    }
  }

  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 4px;

    i {
      color: #909399;
    }
  }

  &__refresh {
    padding: 4px;
    color: #909399;
  }

  &__card-body {
    padding: 16px;
    min-height: 120px;
  }

  &__empty {
    padding: 32px 16px;
    text-align: center;
    color: #c0c4cc;
    font-size: 14px;
    border: 1px dashed #dcdfe6;
    border-radius: 8px;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }
    }
  }

  &__sub-id {
    margin-left: 4px;
    color: #c0c4cc;
    font-size: 12px;
    font-family: Menlo, Monaco, Consolas, monospace;
  }

  &__mono {
    font-family: Menlo, Monaco, Consolas, monospace;
    color: #909399;
  }

  &__status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;

    &.is-active {
      background: #ecfdf5;
      color: #047857;
    }

    &.is-default {
      background: #f3f4f6;
      color: #6b7280;
    }
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .training-bind-history {
    &__info-row {
      grid-template-columns: 1fr;
      gap: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/pages/instruction/TrainingInstructionBindHistory.vue